import * as React from 'react';
import {FunctionComponent} from 'react';
import {FeatureFlags} from '../../../../../../FeatureFlags';
import {Crew} from '../../../../../../Models/Crew';

interface OwnProps {
    crew: Crew;
}

export const CrewActivitiesPromo: FunctionComponent<OwnProps> = ({crew}) => {
    return (
        <div className="card">
            {FeatureFlags.isAdvancedSubscriptionsEnabled && (
                <div className="card-body-promo px-3">
                    <p className="skeleton--visible">Gain insight into the progress of your crew!</p>
                    <p className="skeleton--visible">
                        With our advanced analysis tools, you can now compare workouts side by side — whether it’s
                        sections from the same session or from different days of dropping your split. Track the progress
                        of your crew, spot patterns, and fine-tune their technique like never before.
                    </p>
                    <p>
                        <b>Level up your training — become an Advanced Crew today!</b>
                    </p>
                    <a href={'/account/subscriptions/crew-checkout/' + crew.id} className="btn btn-primary">
                        Become an Advanced Crew
                    </a>
                </div>
            )}
            {!FeatureFlags.isAdvancedSubscriptionsEnabled && (
                <div className="card-body-promo">
                    <p className="skeleton--visible">Gain insight into the progress of your crew!</p>
                    <p className="skeleton--visible">
                        We're working on next level coaching functionality with the RP3 Portal Advanced. Join our beta
                        version to gain crew insights.
                    </p>
                    <a href="/beta" className="btn btn-primary skeleton--visible">
                        Join beta
                    </a>
                </div>
            )}
            <div className="card-title skeleton skeleton--static skeleton--opacity">
                <div className="row">
                    <div className="col-12">
                        <button className="btn btn-outline-primary ms-2 mt-2">Today</button>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 d-flex justify-content-center">
                        <h5 className="d-flex flex-row">
                            <button type="button" className="btn btn-link">
                                <i className="bi bi-chevron-left"></i>
                            </button>
                            <div className="calendar-daterange">
                                {new Date().toLocaleString('en-us', {
                                    month: 'long',
                                    year: 'numeric',
                                })}
                            </div>
                            <button type="button" className="btn btn-link">
                                <i className="bi bi-chevron-right"></i>
                            </button>
                        </h5>
                    </div>
                </div>
            </div>
            <div className="card-body crew-members-grid skeleton skeleton--static skeleton--opacity">
                <div className="crew-members-grid__row crew-members-grid__row--with-borders">
                    <div className="crew-members-grid__cell"></div>
                    <div className="crew-members-grid__cell">
                        <div className="calendar-rsvp__header">
                            <small>Su 26 May</small>
                        </div>
                    </div>
                    <div className="crew-members-grid__cell">
                        <div className="calendar-rsvp__header">
                            <small>Su 2 Jun</small>
                        </div>
                    </div>
                    <div className="crew-members-grid__cell">
                        <div className="calendar-rsvp__header">
                            <small>Su 9 Jun</small>
                        </div>
                    </div>
                    <div className="crew-members-grid__cell">
                        <div className="calendar-rsvp__header">
                            <small>Su 16 Jun</small>
                        </div>
                    </div>
                    <div className="crew-members-grid__cell">
                        <div className="calendar-rsvp__header">
                            <small>Su 23 Jun</small>
                        </div>
                    </div>
                    <div className="crew-members-grid__cell">
                        <div className="calendar-rsvp__header">
                            <small>Su 30 Jun</small>
                        </div>
                    </div>
                </div>
                <div className="crew-members-grid__row crew-members-grid__row--with-borders">
                    <div className="crew-members-grid__cell crew-members-grid__member">
                        <small>...</small>
                    </div>
                </div>
                <div className="crew-members-grid__row crew-members-grid__row--with-borders">
                    <div className="crew-members-grid__cell crew-members-grid__member">
                        <small>...</small>
                    </div>
                </div>
            </div>
        </div>
    );
};
